<template>
  <div class="home">
    <!-- ===== Hero ===== -->
    <section class="hero">
      <!-- 动态背景层 -->
      <div class="hero-bg">
        <div class="hero-grid"></div>
        <div class="hero-orb hero-orb-1"></div>
        <div class="hero-orb hero-orb-2"></div>
        <div class="hero-orb hero-orb-3"></div>
        <div class="hero-scanline"></div>
      </div>

      <div class="container hero-inner">
        <!-- 左栏：内容 -->
        <div class="hero-left">
          <div class="hero-badge" data-aos="fade-up">
            <span class="hero-badge-dot"></span>
            <span class="hero-badge-text">
              <i class="fa-brands fa-android"></i>
              Android · 全栈 · 开源创作者
            </span>
            <span class="hero-badge-meta">{{ workYears }}Y EXP</span>
          </div>

          <h1 class="hero-title" data-aos="fade-up" data-aos-delay="80">
            <span class="hero-title-line">你好，我是</span>
            <span class="hero-title-name">余静</span>
            <span class="hero-title-sub">
              <span class="hero-type-prefix">&gt;</span>
              <span class="hero-type-text">{{ typedText }}</span>
              <span class="hero-cursor"></span>
            </span>
          </h1>

          <p class="hero-desc" data-aos="fade-up" data-aos-delay="160">
            {{ workYears }} 年深耕 Android 与 Java 开发，中国烟草西南大区 20+ 项目长期运维。
            原创四大开源库累计服务众多开发者，横跨 ESP32、小程序、Spring Boot 全栈技术栈。
          </p>

          <div class="hero-actions" data-aos="fade-up" data-aos-delay="220">
            <router-link to="/opensource" class="btn btn-primary hero-btn-primary">
              <i class="fa-solid fa-rocket"></i>
              <span>浏览开源作品</span>
              <i class="fa-solid fa-arrow-right hero-btn-arrow"></i>
            </router-link>
            <router-link to="/resume" class="btn btn-ghost">
              <i class="fa-solid fa-file-lines"></i> 查看简历
            </router-link>
            <a :href="site.github" target="_blank" rel="noopener" class="btn btn-ghost">
              <i class="fa-brands fa-github"></i> GitHub
            </a>
          </div>

          <div class="hero-tech-strip" data-aos="fade-up" data-aos-delay="300">
            <span class="hero-tech-label">技术栈</span>
            <div class="hero-tech-list">
              <span v-for="t in heroTech" :key="t" class="hero-tech-chip">
                <i class="fa-solid fa-code"></i> {{ t }}
              </span>
            </div>
          </div>
        </div>

        <!-- 右栏：浮动卡片堆叠 -->
        <div class="hero-right" data-aos="fade-left" data-aos-delay="300">
          <!-- 主代码窗口 -->
          <div class="hero-card hero-card-main">
            <div class="hero-card-bar">
              <span class="code-dot red"></span>
              <span class="code-dot yellow"></span>
              <span class="code-dot green"></span>
              <span class="hero-card-title">kotlinx.kt</span>
              <span class="hero-card-lang">Kotlin</span>
            </div>
            <pre class="hero-card-code"><span class="hc-comment">// 一行代码完成常用操作</span>
<span class="hc-keyword">"你好"</span>.<span class="hc-func">toast</span>()
     .<span class="hc-func">speak</span>()
     .<span class="hc-func">logE</span>()

<span class="hc-comment">// RecyclerView 一行绑定</span>
recyclerView.<span class="hc-func">show</span>(R.layout.item, list) { ... }

<span class="hc-comment">// 串口通信自动组包</span>
ySerialPort.<span class="hc-func">setToAuto</span>().<span class="hc-func">start</span>()</pre>
          </div>

          <!-- 浮动统计卡 -->
          <div class="hero-card hero-card-stat">
            <div class="hero-stat-icon" style="color: #34D399; background: #34D39914;">
              <i class="fa-brands fa-android"></i>
            </div>
            <div class="hero-stat-info">
              <div class="hero-stat-num">20<span>+</span></div>
              <div class="hero-stat-label">实战项目</div>
            </div>
            <div class="hero-stat-spark"></div>
          </div>

          <!-- 浮动开源卡 -->
          <div class="hero-card hero-card-oss">
            <div class="hero-oss-head">
              <i class="fa-solid fa-code-branch"></i>
              <span>开源贡献</span>
            </div>
            <div class="hero-oss-list">
              <div class="hero-oss-item">
                <span class="hero-oss-dot" style="background: #22D3EE;"></span>
                <span class="hero-oss-name">kotlinx</span>
                <i class="fa-solid fa-star hero-oss-star"></i>
              </div>
              <div class="hero-oss-item">
                <span class="hero-oss-dot" style="background: #38BDF8;"></span>
                <span class="hero-oss-name">YSerialPort</span>
                <i class="fa-solid fa-star hero-oss-star"></i>
              </div>
              <div class="hero-oss-item">
                <span class="hero-oss-dot" style="background: #34D399;"></span>
                <span class="hero-oss-name">yutils</span>
                <i class="fa-solid fa-star hero-oss-star"></i>
              </div>
              <div class="hero-oss-item">
                <span class="hero-oss-dot" style="background: #818CF8;"></span>
                <span class="hero-oss-name">yuvc</span>
                <i class="fa-solid fa-star hero-oss-star"></i>
              </div>
            </div>
          </div>

          <!-- 浮动全栈标签 -->
          <div class="hero-card hero-card-fullstack">
            <i class="fa-solid fa-layer-group hero-fs-icon"></i>
            <span class="hero-fs-text">全栈能力</span>
            <div class="hero-fs-tags">
              <span>ESP32</span>
              <span>小程序</span>
              <span>SpringBoot</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 滚动指示器 -->
      <div class="hero-scroll" data-aos="fade-up" data-aos-delay="500">
        <span class="hero-scroll-text">向下滚动探索</span>
        <div class="hero-scroll-mouse">
          <span class="hero-scroll-wheel"></span>
        </div>
      </div>
    </section>

    <!-- ===== 数据统计 ===== -->
    <section class="section stats-section">
      <div class="container">
        <div class="stats-grid">
          <div v-for="(s, i) in homeStats" :key="s.label" class="stat-box" data-aos="zoom-in" :data-aos-delay="i * 60">
            <div class="stat-icon"><i :class="s.icon"></i></div>
            <div class="stat-num">
              <span class="counter">{{ s.display }}</span>
              <span class="stat-suffix">{{ s.suffix }}</span>
            </div>
            <div class="stat-text">{{ s.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 业务领域 ===== -->
    <section class="section">
      <div class="container">
        <div data-aos="fade-up">
          <span class="section-eyebrow">DOMAINS</span>
          <h2 class="section-title">四大业务领域</h2>
          <p class="section-subtitle">从烟草行业全链路到物联网回收生态，从开源工具到全栈拓展，覆盖软硬件交付全流程</p>
        </div>
        <div class="domain-grid">
          <div v-for="(d, i) in domains" :key="d.title" class="domain-card" data-aos="fade-up" :data-aos-delay="i * 70">
            <div class="domain-icon" :style="{ color: d.color, background: d.color + '14', borderColor: d.color + '44' }">
              <i :class="d.icon"></i>
            </div>
            <h3 class="domain-title">{{ d.title }}</h3>
            <p class="domain-desc">{{ d.desc }}</p>
            <div class="domain-tags">
              <span v-for="t in d.tags" :key="t" class="domain-tag">{{ t }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 开源项目 ===== -->
    <section class="section">
      <div class="container">
        <div class="ov-head" data-aos="fade-up">
          <div>
            <span class="section-eyebrow">OPEN SOURCE</span>
            <h2 class="section-title">四个核心开源项目</h2>
            <p class="section-subtitle">从 Kotlin 扩展到串口通信，从工具集合到 UVC 摄像头，覆盖 Android 开发高频场景。均发布至 Maven 中央仓库。</p>
          </div>
          <router-link to="/opensource" class="btn btn-ghost more-btn">
            项目总览 <i class="fa-solid fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="proj-grid">
          <router-link
            v-for="(p, i) in projectCards"
            :key="p.key"
            :to="p.to"
            class="proj-card"
            :class="{ offset: i % 2 === 1 }"
            data-aos="fade-up"
            :data-aos-delay="i * 80"
          >
            <div class="proj-card-glow" :style="{ background: p.color }"></div>
            <div class="proj-card-head">
              <div class="proj-icon" :style="{ background: p.color + '1f', color: p.color, borderColor: p.color + '44' }">
                <i :class="p.icon"></i>
              </div>
              <a :href="p.repo" target="_blank" rel="noopener" class="proj-ext" @click.stop>
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </a>
            </div>
            <h3 class="proj-name">{{ p.name }}</h3>
            <p class="proj-tagline">{{ p.tagline }}</p>
            <div class="proj-tags">
              <span v-for="t in p.tags" :key="t" class="proj-tag">{{ t }}</span>
            </div>
            <div class="proj-foot">
              <span class="proj-lang"><i class="fa-solid fa-code"></i> {{ p.language }}</span>
              <span class="proj-repo-link"><i class="fa-solid fa-arrow-up-right-from-square"></i> 仓库</span>
            </div>
            <div class="proj-cta">
              查看详情 <i class="fa-solid fa-arrow-right"></i>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- ===== 精选实战项目 ===== -->
    <section class="section featured-section">
      <div class="container">
        <div class="featured-head" data-aos="fade-up">
          <div>
            <span class="section-eyebrow">REAL PROJECTS</span>
            <h2 class="section-title">精选实战项目</h2>
            <p class="section-subtitle">中国烟草西南大区核心项目 + 物联网回收生态 + ESP32 + 小程序，部分项目长期运维至今</p>
          </div>
          <router-link to="/resume" class="btn btn-ghost more-btn">
            查看全部 <i class="fa-solid fa-arrow-right"></i>
          </router-link>
        </div>

        <div class="featured-grid">
          <div v-for="(p, i) in featuredProjects" :key="p.name" class="fp-card" data-aos="fade-up" :data-aos-delay="(i % 3) * 60">
            <div class="fp-head">
              <span class="fp-time">{{ p.time }}</span>
              <span class="fp-role">{{ p.role }}</span>
            </div>
            <h3 class="fp-name">{{ p.name }}</h3>
            <div class="fp-tags">
              <span v-for="t in p.tags.slice(0, 4)" :key="t" class="fp-tag">{{ t }}</span>
            </div>
            <p class="fp-desc">{{ p.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 技术栈 ===== -->
    <section class="section">
      <div class="container">
        <div data-aos="fade-up">
          <span class="section-eyebrow">TECH STACK</span>
          <h2 class="section-title">技术栈一览</h2>
          <p class="section-subtitle">{{ workYears }} 年沉淀的全栈技术能力，从移动端底层到后端服务，从硬件通信到全栈 Web。</p>
        </div>
        <div class="stack-grid">
          <div v-for="(stack, i) in techStack" :key="stack.group" class="stack-card" data-aos="fade-up" :data-aos-delay="i * 60">
            <div class="stack-head">
              <i :class="stack.icon" class="stack-icon"></i>
              <h3 class="stack-group">{{ stack.group }}</h3>
            </div>
            <div class="stack-items">
              <span v-for="item in stack.items" :key="item" class="stack-chip">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 联系入口 ===== -->
    <section class="section cta-section">
      <div class="container">
        <div class="cta-box" data-aos="fade-up">
          <div class="glow-orb" style="background: var(--accent); top: -40px; left: 30%; width: 300px; height: 300px; opacity: 0.2;"></div>
          <div class="cta-inner">
            <span class="section-eyebrow">GET IN TOUCH</span>
            <h2 class="section-title">合作 · 交流 · 招聘</h2>
            <p class="section-subtitle">无论是技术交流、项目合作还是招聘沟通，欢迎随时联系。开源项目长期维护，欢迎 Star 与 Issue。</p>
            <div class="cta-actions">
              <router-link to="/resume" class="btn btn-primary">
                <i class="fa-solid fa-file-lines"></i> 查看完整简历
              </router-link>
              <a :href="site.github" target="_blank" rel="noopener" class="btn btn-ghost">
                <i class="fa-brands fa-github"></i> GitHub
              </a>
              <a :href="`mailto:${site.email}`" class="btn btn-ghost">
                <i class="fa-solid fa-envelope"></i> 邮箱
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { projectCards, techStack } from '@/data/projects.js'
import { resume } from '@/data/resume.js'
import { site } from '@/data/site.js'

// 动态工作年限（与简历页一致，1992出生/2015工作）
const workYears = new Date().getFullYear() - 2015

// Hero 技术栈小标签
const heroTech = ['Kotlin', 'Java', 'Android', 'NDK', 'ESP32', 'SpringBoot', 'Vue', '小程序']

// 打字机效果
const typeWords = ['用代码沉淀工具', '用工具解放开发', '用全栈解决问题', '用开源回馈社区']
const typedText = ref('')
let typeTimer = null
const startTyping = () => {
  let wordIdx = 0
  let charIdx = 0
  let isDeleting = false
  const tick = () => {
    const word = typeWords[wordIdx]
    if (!isDeleting) {
      typedText.value = word.substring(0, charIdx + 1)
      charIdx++
      if (charIdx === word.length) {
        isDeleting = true
        typeTimer = setTimeout(tick, 1800)
        return
      }
    } else {
      typedText.value = word.substring(0, charIdx - 1)
      charIdx--
      if (charIdx === 0) {
        isDeleting = false
        wordIdx = (wordIdx + 1) % typeWords.length
      }
    }
    typeTimer = setTimeout(tick, isDeleting ? 60 : 110)
  }
  tick()
}

// 数据统计（真实数字）
const homeStats = ref([
  { value: 20, label: 'Android 实战项目', suffix: '+', display: 0, icon: 'fa-brands fa-android' },
  { value: workYears, label: '年开发经验', suffix: '', display: 0, icon: 'fa-solid fa-briefcase' },
  { value: 4, label: '开源工具库', suffix: '', display: 0, icon: 'fa-solid fa-code-branch' },
  { value: 4.4, label: '至 14.0 兼容', suffix: '', display: 0, icon: 'fa-solid fa-mobile-screen' }
])

// 精选实战项目（从简历中选 6 个代表性的）
const featuredProjects = resume.portfolioProjects.slice(0, 6)

const animateCount = () => {
  homeStats.value.forEach((s) => {
    const target = s.value
    const duration = 1400
    const start = performance.now()
    const step = (now) => {
      const p = Math.min((now - start) / duration, 1)
      const ease = 1 - Math.pow(1 - p, 3)
      s.display = (target * ease).toFixed(target % 1 === 0 ? 0 : 1)
      if (p < 1) requestAnimationFrame(step)
      else s.display = target
    }
    requestAnimationFrame(step)
  })
}

onMounted(() => {
  setTimeout(animateCount, 300)
  setTimeout(startTyping, 800)
})

onUnmounted(() => {
  if (typeTimer) clearTimeout(typeTimer)
})

// 业务领域
const domains = [
  {
    title: '烟草行业全链路',
    icon: 'fa-solid fa-leaf',
    color: '#34D399',
    desc: '中国烟草西南大区（凉山/攀枝花）烟叶收购仓储全流程：排号→交售刷卡→定级→磅码→打包→扫码→预检预约→二检→入库→出库→盘点→运维。',
    tags: ['20+ 项目', '7年+ 运维', '多地区分仓']
  },
  {
    title: '物联网回收生态',
    icon: 'fa-solid fa-recycle',
    color: '#38BDF8',
    desc: '「大卫智能」垃圾分类回收全栈：Spring Boot 后端 + Android 清运端 + 微信小程序用户端 + ESP32 蓝牙电子秤，MQTT 设备控制与 OTA 升级。',
    tags: ['Spring Boot', 'MQTT', '小程序', 'ESP32']
  },
  {
    title: '开源工具生态',
    icon: 'fa-solid fa-code-branch',
    color: '#818CF8',
    desc: '四大 Android 开源工具库原创作者：kotlinx 扩展方法、YSerialPort 串口通信、yutils 工具集合、yuvc UVC 摄像头，均发布至 Maven 中央仓库。',
    tags: ['kotlinx', 'YSerialPort', 'yutils', 'yuvc']
  },
  {
    title: '全栈技术拓展',
    icon: 'fa-solid fa-layer-group',
    color: '#22D3EE',
    desc: '从 Android 原生拓展至 ESP32 固件（Arduino/PlatformIO）、微信小程序（原生+Vant）、Spring Boot 后端、Vue 前端，覆盖软硬件全栈。',
    tags: ['ESP32', '小程序', 'Spring Boot', 'NDK/JNI']
  }
]
</script>

<style scoped>
/* ===== Hero ===== */
.hero {
  position: relative;
  padding: 100px 0 80px;
  overflow: hidden;
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
}

/* 动态背景层 */
.hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}
.hero-grid {
  position: absolute;
  inset: -20%;
  background-image:
    linear-gradient(rgba(56, 189, 248, 0.06) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, 0.06) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 40%, transparent 100%);
  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 40%, #000 40%, transparent 100%);
  animation: grid-pan 30s linear infinite;
}
@keyframes grid-pan {
  0% { transform: translate(0, 0); }
  100% { transform: translate(48px, 48px); }
}
.hero-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.35;
  animation: orb-float 18s ease-in-out infinite;
}
.hero-orb-1 {
  background: var(--accent);
  top: -120px; left: -80px;
  width: 520px; height: 520px;
}
.hero-orb-2 {
  background: #818CF8;
  bottom: -100px; right: -60px;
  width: 440px; height: 440px;
  opacity: 0.25;
  animation-delay: -6s;
}
.hero-orb-3 {
  background: #34D399;
  top: 40%; right: 25%;
  width: 280px; height: 280px;
  opacity: 0.15;
  animation-delay: -12s;
}
@keyframes orb-float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(40px, -30px) scale(1.08); }
  66% { transform: translate(-30px, 40px) scale(0.95); }
}
.hero-scanline {
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--accent), transparent);
  opacity: 0.4;
  animation: scan 8s ease-in-out infinite;
}
@keyframes scan {
  0%, 100% { transform: translateY(0); opacity: 0; }
  10%, 90% { opacity: 0.4; }
  50% { transform: translateY(100vh); opacity: 0.4; }
}

/* Hero 主体布局 */
.hero-inner {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 60px;
  align-items: center;
}

/* 左栏 */
.hero-left { min-width: 0; }
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 7px 14px 7px 10px;
  border: 1px solid var(--border);
  border-radius: 100px;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  color: var(--text-muted);
  background: rgba(22, 27, 34, 0.6);
  backdrop-filter: blur(10px);
  margin-bottom: 32px;
}
.hero-badge-dot {
  width: 8px; height: 8px;
  background: #34D399;
  border-radius: 50%;
  box-shadow: 0 0 10px #34D399;
  animation: float 2s ease-in-out infinite;
}
.hero-badge-text { display: inline-flex; align-items: center; gap: 7px; }
.hero-badge-text i { color: var(--accent); }
.hero-badge-meta {
  padding: 2px 8px;
  background: var(--accent);
  color: var(--bg-base);
  border-radius: 100px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.05em;
}

.hero-title {
  font-family: var(--font-display);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.02;
  margin-bottom: 28px;
}
.hero-title-line {
  display: block;
  font-size: clamp(1rem, 2vw, 1.3rem);
  color: var(--text-dim);
  font-weight: 400;
  font-family: var(--font-mono);
  margin-bottom: 12px;
  letter-spacing: 0.02em;
}
.hero-title-name {
  display: block;
  font-size: clamp(4rem, 11vw, 8rem);
  line-height: 0.95;
  background: linear-gradient(135deg, var(--text) 0%, var(--accent) 60%, #818CF8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 18px;
  position: relative;
}
.hero-title-name::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, var(--accent), transparent);
  border-radius: 2px;
}
.hero-title-sub {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: clamp(1.4rem, 3.2vw, 2.2rem);
  color: var(--text);
  font-weight: 600;
  font-family: var(--font-mono);
  min-height: 2.4em;
}
.hero-type-prefix { color: var(--accent); font-weight: 700; }
.hero-type-text { color: var(--text); }
.hero-cursor {
  display: inline-block;
  width: 3px;
  height: 1.2em;
  background: var(--accent);
  margin-left: 4px;
  animation: blink 1s steps(2) infinite;
  vertical-align: middle;
}
@keyframes blink { 50% { opacity: 0; } }

.hero-desc {
  color: var(--text-muted);
  font-size: 1.08rem;
  line-height: 1.8;
  max-width: 560px;
  margin-bottom: 36px;
}

.hero-actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 36px;
}
.hero-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  position: relative;
  overflow: hidden;
}
.hero-btn-primary .hero-btn-arrow {
  transition: transform 0.3s ease;
}
.hero-btn-primary:hover .hero-btn-arrow {
  transform: translateX(4px);
}

/* 技术栈条 */
.hero-tech-strip {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 28px;
  border-top: 1px solid var(--border-soft);
}
.hero-tech-label {
  font-family: var(--font-mono);
  font-size: 0.76rem;
  color: var(--text-dim);
  letter-spacing: 0.15em;
  white-space: nowrap;
}
.hero-tech-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.hero-tech-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  font-size: 0.78rem;
  font-family: var(--font-mono);
  color: var(--text-muted);
  transition: all 0.25s ease;
}
.hero-tech-chip i { color: var(--accent); font-size: 0.7rem; }
.hero-tech-chip:hover {
  color: var(--text);
  border-color: var(--accent);
  transform: translateY(-2px);
}

/* 右栏：浮动卡片堆叠 */
.hero-right {
  position: relative;
  min-height: 480px;
}
.hero-card {
  position: absolute;
  background: rgba(13, 17, 23, 0.85);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

/* 主代码窗口 */
.hero-card-main {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  animation: card-float-1 6s ease-in-out infinite;
}
@keyframes card-float-1 {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}
.hero-card-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(22, 27, 34, 0.9);
  border-bottom: 1px solid var(--border);
  border-radius: 14px 14px 0 0;
}
.code-dot { width: 11px; height: 11px; border-radius: 50%; }
.code-dot.red { background: #ff5f56; }
.code-dot.yellow { background: #ffbd2e; }
.code-dot.green { background: #27c93f; }
.hero-card-title {
  margin-left: 10px;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--text-dim);
}
.hero-card-lang {
  margin-left: auto;
  padding: 2px 8px;
  background: rgba(56, 189, 248, 0.15);
  color: var(--accent);
  border-radius: 4px;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 600;
}
.hero-card-code {
  margin: 0;
  padding: 20px 22px;
  font-family: var(--font-mono);
  font-size: 0.84rem;
  line-height: 1.85;
  color: var(--text-muted);
  white-space: pre;
  overflow-x: auto;
}
.hc-comment { color: #6b7280; font-style: italic; }
.hc-keyword { color: #a5b6cf; }
.hc-func { color: var(--accent); }

/* 浮动统计卡 */
.hero-card-stat {
  top: 30px;
  right: -30px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  z-index: 4;
  animation: card-float-2 7s ease-in-out infinite;
}
@keyframes card-float-2 {
  0%, 100% { transform: translateY(0) rotate(2deg); }
  50% { transform: translateY(-12px) rotate(2deg); }
}
.hero-stat-icon {
  width: 42px; height: 42px;
  display: grid; place-items: center;
  border-radius: 10px;
  font-size: 1.2rem;
  border: 1px solid var(--border);
}
.hero-stat-info { line-height: 1.2; }
.hero-stat-num {
  font-family: var(--font-mono);
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text);
}
.hero-stat-num span { color: var(--accent); }
.hero-stat-label {
  font-size: 0.76rem;
  color: var(--text-dim);
  margin-top: 2px;
}

/* 浮动开源卡 */
.hero-card-oss {
  bottom: 60px;
  left: -40px;
  width: 200px;
  padding: 16px 18px;
  z-index: 4;
  animation: card-float-3 8s ease-in-out infinite;
}
@keyframes card-float-3 {
  0%, 100% { transform: translateY(0) rotate(-3deg); }
  50% { transform: translateY(-10px) rotate(-3deg); }
}
.hero-oss-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-soft);
}
.hero-oss-head i { color: var(--accent); }
.hero-oss-list { display: flex; flex-direction: column; gap: 8px; }
.hero-oss-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-mono);
  font-size: 0.78rem;
}
.hero-oss-dot { width: 8px; height: 8px; border-radius: 50%; }
.hero-oss-name { color: var(--text-muted); flex: 1; }
.hero-oss-star { color: #fbbf24; font-size: 0.7rem; }

/* 浮动全栈卡 */
.hero-card-fullstack {
  bottom: 0;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  z-index: 4;
  animation: card-float-4 9s ease-in-out infinite;
}
@keyframes card-float-4 {
  0%, 100% { transform: translateY(0) rotate(1deg); }
  50% { transform: translateY(-14px) rotate(1deg); }
}
.hero-fs-icon { color: #818CF8; font-size: 1rem; }
.hero-fs-text { font-size: 0.82rem; font-weight: 600; color: var(--text); }
.hero-fs-tags { display: flex; gap: 5px; }
.hero-fs-tags span {
  padding: 2px 7px;
  background: rgba(129, 140, 248, 0.15);
  color: #a5b4fc;
  border-radius: 4px;
  font-size: 0.7rem;
  font-family: var(--font-mono);
}

/* 滚动指示器 */
.hero-scroll {
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 5;
}
.hero-scroll-text {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  color: var(--text-dim);
  letter-spacing: 0.15em;
  text-transform: uppercase;
}
.hero-scroll-mouse {
  width: 22px;
  height: 36px;
  border: 2px solid var(--text-dim);
  border-radius: 12px;
  display: grid;
  place-items: start center;
  padding-top: 6px;
}
.hero-scroll-wheel {
  width: 3px;
  height: 8px;
  background: var(--accent);
  border-radius: 2px;
  animation: scroll-wheel 1.6s ease-in-out infinite;
}
@keyframes scroll-wheel {
  0% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(14px); opacity: 0; }
}

/* 响应式 */
@media (max-width: 1100px) {
  .hero-inner { grid-template-columns: 1fr; gap: 40px; }
  .hero-right { min-height: 380px; max-width: 560px; }
  .hero-card-oss { left: 0; }
  .hero-card-stat { right: 0; }
}
@media (max-width: 768px) {
  .hero { padding: 80px 0 60px; }
  .hero-right { display: none; }
  .hero-scroll { display: none; }
  .hero-tech-strip { flex-direction: column; align-items: flex-start; gap: 10px; }
}

/* ===== 数据统计 ===== */
.stats-section { padding: 64px 0; border-top: 1px solid var(--border-soft); border-bottom: 1px solid var(--border-soft); }
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: var(--border-soft);
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  overflow: hidden;
}
.stat-box {
  background: var(--bg-base);
  padding: 44px 20px;
  text-align: center;
  transition: background 0.25s ease;
}
.stat-box:hover { background: var(--bg-surface); }
.stat-icon {
  font-size: 1.6rem;
  color: var(--accent);
  margin-bottom: 16px;
  opacity: 0.8;
  transition: all 0.3s ease;
}
.stat-box:hover .stat-icon {
  opacity: 1;
  transform: scale(1.1) translateY(-2px);
}
.stat-num {
  font-family: var(--font-mono);
  font-size: clamp(2.4rem, 4vw, 3.4rem);
  font-weight: 700;
  color: var(--accent);
  line-height: 1;
  margin-bottom: 10px;
}
.stat-suffix { font-size: 1.4rem; }
.stat-text { color: var(--text-muted); font-size: 0.9rem; }

/* ===== 业务领域 ===== */
.domain-grid { margin-top: 56px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 22px; }
.domain-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius);
  padding: 30px 28px;
  transition: all 0.3s ease;
}
.domain-card:hover { border-color: var(--border); transform: translateY(-4px); }
.domain-icon { width: 52px; height: 52px; display: grid; place-items: center; border-radius: 13px; font-size: 1.35rem; border: 1px solid var(--border); margin-bottom: 18px; }
.domain-title { font-family: var(--font-display); font-weight: 600; font-size: 1.3rem; margin-bottom: 10px; }
.domain-desc { color: var(--text-muted); font-size: 0.94rem; line-height: 1.75; margin-bottom: 16px; }
.domain-tags { display: flex; flex-wrap: wrap; gap: 7px; }
.domain-tag {
  font-family: var(--font-mono);
  font-size: 0.74rem;
  padding: 3px 10px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-soft);
  border-radius: 100px;
  color: var(--text-muted);
}

/* ===== 开源项目卡片 ===== */
.ov-head { margin-bottom: 20px; }
.proj-grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.proj-card {
  position: relative;
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius);
  padding: 32px 30px;
  transition: all 0.35s ease;
  overflow: hidden;
  display: block;
}
.proj-card.offset { transform: translateY(36px); }
.proj-card-glow {
  position: absolute;
  top: -80px; right: -80px;
  width: 200px; height: 200px;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.12;
  transition: opacity 0.35s ease;
}
.proj-card:hover {
  border-color: var(--border);
  transform: translateY(-6px);
  box-shadow: var(--shadow);
}
.proj-card.offset:hover { transform: translateY(30px); }
.proj-card:hover .proj-card-glow { opacity: 0.25; }
.proj-card:hover .proj-cta { color: var(--accent); gap: 14px; }
.proj-card-head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 22px; }
.proj-icon {
  width: 56px; height: 56px;
  display: grid; place-items: center;
  border-radius: 14px;
  font-size: 1.5rem;
  border: 1px solid var(--border);
}
.proj-ext { color: var(--text-dim); font-size: 0.9rem; padding: 8px; transition: color 0.2s ease; }
.proj-ext:hover { color: var(--accent); }
.proj-name { font-family: var(--font-display); font-weight: 600; font-size: 1.7rem; margin-bottom: 8px; letter-spacing: -0.01em; }
.proj-tagline { color: var(--text-muted); font-size: 0.98rem; line-height: 1.6; margin-bottom: 18px; }
.proj-tags { display: flex; flex-wrap: wrap; gap: 7px; margin-bottom: 22px; }
.proj-tag {
  font-family: var(--font-mono);
  font-size: 0.72rem;
  padding: 3px 10px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-soft);
  border-radius: 100px;
  color: var(--text-muted);
}
.proj-foot {
  display: flex; justify-content: space-between; align-items: center;
  padding-top: 18px; border-top: 1px solid var(--border-soft);
  font-size: 0.82rem; color: var(--text-dim); font-family: var(--font-mono);
}
.proj-lang { display: inline-flex; align-items: center; gap: 6px; }
.proj-repo-link { display: inline-flex; align-items: center; gap: 6px; color: var(--accent); }
.proj-cta {
  margin-top: 18px; display: inline-flex; align-items: center; gap: 8px;
  font-size: 0.88rem; font-weight: 600; color: var(--text-muted);
  transition: all 0.25s ease;
}

/* ===== 精选实战项目 ===== */
.featured-section { border-top: 1px solid var(--border-soft); }
.featured-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  flex-wrap: wrap;
}
.more-btn { flex-shrink: 0; }
.featured-grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.fp-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius);
  padding: 26px 24px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}
.fp-card:hover { border-color: var(--border); transform: translateY(-4px); }
.fp-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px; gap: 10px; }
.fp-time { font-family: var(--font-mono); font-size: 0.76rem; color: var(--accent); }
.fp-role { font-size: 0.7rem; padding: 2px 9px; background: var(--accent-soft); color: var(--accent); border-radius: 100px; font-weight: 600; }
.fp-name { font-family: var(--font-display); font-weight: 600; font-size: 1.1rem; margin-bottom: 12px; line-height: 1.3; }
.fp-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 14px; }
.fp-tag {
  font-family: var(--font-mono);
  font-size: 0.68rem;
  padding: 2px 8px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-soft);
  border-radius: 4px;
  color: var(--lime);
}
.fp-desc { color: var(--text-muted); font-size: 0.86rem; line-height: 1.7; flex: 1; }

/* ===== 技术栈 ===== */
.stack-grid {
  margin-top: 56px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.stack-card {
  background: var(--bg-surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius);
  padding: 26px 24px;
  transition: all 0.3s ease;
}
.stack-card:hover { border-color: var(--border); transform: translateY(-3px); }
.stack-head { display: flex; align-items: center; gap: 12px; margin-bottom: 18px; }
.stack-icon {
  width: 40px; height: 40px;
  display: grid; place-items: center;
  border-radius: 10px;
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 1.05rem;
}
.stack-group { font-family: var(--font-display); font-weight: 600; font-size: 1.15rem; }
.stack-items { display: flex; flex-wrap: wrap; gap: 7px; }
.stack-chip {
  font-size: 0.8rem;
  padding: 5px 11px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-soft);
  border-radius: 6px;
  color: var(--text-muted);
  transition: all 0.2s ease;
}
.stack-chip:hover { color: var(--accent); border-color: var(--accent); }

/* ===== CTA ===== */
.cta-section { padding-top: 80px; }
.cta-box {
  position: relative;
  background: linear-gradient(135deg, var(--bg-surface), var(--bg-elevated));
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 64px 48px;
  overflow: hidden;
  text-align: center;
}
.cta-inner { position: relative; z-index: 1; }
.cta-inner .section-title { text-align: center; }
.cta-inner .section-subtitle { margin: 0 auto 32px; }
.cta-actions { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; }

@media (max-width: 1024px) {
  .stack-grid { grid-template-columns: repeat(2, 1fr); }
  .featured-grid { grid-template-columns: repeat(2, 1fr); }
  .domain-grid { grid-template-columns: 1fr; }
}
@media (max-width: 768px) {
  .proj-grid { grid-template-columns: 1fr; }
  .proj-card.offset { transform: none; }
  .proj-card.offset:hover { transform: translateY(-6px); }
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
  .stack-grid { grid-template-columns: 1fr; }
  .featured-grid { grid-template-columns: 1fr; }
  .featured-head { flex-direction: column; align-items: flex-start; }
}
</style>
